<template>
	<td :class="cellCssClass">
		<span v-if="!hasRoute && !hasComponent && !hasButtons" v-html="cellValue" />
        <a v-if="hasRoute" :href="dynamicRoute" :target="target" v-html="cellValue">{{ cellValue }}</a>
		<template v-if="hasButtons">
			<button v-for="button in header.buttons" @click="sendEmit(button.event)" class="uk-button-link" style="background: none;border: none;"><i :class="button.faClass"></i></button>
		</template>
		<template v-if="hasLinks">
			<a v-for="link in header.links" :href="processRoute(link.route)" :target="target" class="uk-button-link" style="background: none;border: none; margin-left: 5px;"><i :class="link.faClass"></i> </a>
		</template>
		<component
			:is="header.component"
			:cell_data='cell_data'
            :field="field"
            :header="header"
			v-if="hasComponent" />
	</td>
</template>

<script>
    import FilledJobCell from "./FilledJobCell";
    import NameClusterCell from "./NameClusterCell";
	export default {
		name: 'data-table-cell',
		components: {
            FilledJobCell,
            NameClusterCell
		},
		props: {
			header: {
				type: Object,
				default: () => {}
			},
			cell_data: {
				type: Object,
				default: () => {}
			},
			field: {
				type: String,
				default: () => ""
			},
			id_field: {
				type: String,
				default: 'id'
			},
		},
		data(){
			return {
				tdComp: null
			}
		},
		methods: {
			sendEmit(event){
				this.$emit(event, this.getId);
			},
			processRoute(route){
				let matches = route.match(/\{(.*?)\}/gs);
				if(matches){
					//eslint-disable-next-line
					let self = this;
					matches.forEach(match => {
						let field = match.replace(/[{}]/g,"");
						try{
							let value = eval(`self.cell_data.${field}`);
							route = route.replace(`{${field}}`,value);
						}catch(e){
							//route = "";
						}
					});
				}
				return route;
			},
		},
		computed: {
			/**
			* return cell value
			* format if set in header settings
			* @param  {mixed} value  value for cell
			* @param  {obj} header header settings
			* @return {mixed} formatted value
			*/
			cellValue(){
				// check for render function
				if(this.header.render != undefined) return this.header.render(this.cell_data);

				// try to get value from field name
				let value = "";
				try{
					value = eval(`this.cell_data.${this.field}`);
				//eslint-disable-next-line
				}catch(e){
				}
				if(this.header.format == undefined){
					return value;
				}
				// format value if need.
				switch(this.header.format){
					case "empty":
						return "";
                    case "date_time":
                        if(value == null) return "";
                        value = this.$moment(value).format("MMM-DD-YYYY hh:mm a");
                        break;
                    case "date":
                        if(value == null) return "";
                        value = this.$moment(value).format("MMM-DD-YYYY");
                        break;
                    case "local_date_time":
                        if(value == null) return "";
                        value = this.$moment(value).utc(value).local().format("MMM DD, YYYY hh:mm a");
                        break;
                    case "local_date":
                        if(value == null) return "";
                        value = this.$moment(value).utc(value).local().format("MM/DD/YYYY");
                        break;
                    case "edit_fallback":
                     	if(value == null || value == ""){
                     		return "<i class=\"far fa-edit\"></i>";
						}
                     	return value;
                     	break;
                }
				return value;
			},
			/**
			 * match cell data to create a url.
			 * @return {string} url
			 */
			dynamicRoute(){
				let route = this.header.route;
				let matches = route.match(/\{(.*?)\}/gs);
				if(matches){
					//eslint-disable-next-line
					let self = this;
					matches.forEach(match => {
						let field = match.replace(/[{}]/g,"");
						try{
							let value = eval(`self.cell_data.${field}`);
							route = route.replace(`{${field}}`,value);
						}catch(e){
							//route = "";
						}
					});
				}
				return route;
			},
			/**
			 * check wether the cell should use a custom component
			 * @return {Boolean} [description]
			 */
			hasComponent(){
				return this.header.component != undefined;
			},
			hasRoute(){
				return this.header.route != undefined;
			},
			cellCssClass(){
				return (this.header.css_class != undefined)? this.header.css_class : "";
			},
			hasButtons(){
				return this.header.buttons != undefined && this.header.buttons.length > 0;
			},
			hasLinks(){
				return this.header.links != undefined && this.header.links.length > 0;
			},
            target(){
			    return (this.header.target != undefined) ? this.header.target:"_self";
            },
			getId(){
				return this.cell_data[this.id_field];
			},
		}
	}
</script>
